import React, { Suspense, lazy } from 'react';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import retry from '../../utils/webpack/chunkRetry';
const Editor = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "editor-fallback" */ './Fallback')));
export const LoadableFallback = (props)=>{
    const mounted = useIsMounted();
    if (!mounted) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "FallbackEditor"
    }, /*#__PURE__*/ React.createElement(Suspense, {
        fallback: null
    }, /*#__PURE__*/ React.createElement(Editor, props)));
};
LoadableFallback.displayName = 'LoadableFallback';
export default LoadableFallback;
